import React from "react";

import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface AlertSucessDialogProps {
  open: boolean;
  message: string;
  onClose: () => void;
  icon: React.ReactNode;
}

export default function AlertSucessDialog({
  open,
  message,
  onClose,
  icon,
}: AlertSucessDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
          paddingTop: "40px",
        },
      }}
    >
      <DialogContent id="alert-dialog-title" sx={{ position: "relative" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            padding:"5px"
          }}
        >
          {icon}
          {message}
        </Box>

        <IconButton
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
}
